import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut as firebaseSignOut } from 'firebase/auth';



const firebaseConfig = {
  apiKey: "AIzaSyCIhohgI0sM2w3mCcn-pJEDypBPluyTPLE",
  authDomain: "emmerson-gray-eu.firebaseapp.com",
  projectId: "emmerson-gray-eu",
  storageBucket: "emmerson-gray-eu.firebasestorage.app",
  messagingSenderId: "790868080687",
  appId: "1:790868080687:web:150afc96c853820946eeda"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

export async function signIn() {
  const provider = new GoogleAuthProvider();
  // Force the Google popup to only accept emails from this specific domain
  provider.setCustomParameters({
    hd: 'emmersongray.co.uk'
  });

  try {
    const result = await signInWithPopup(auth, provider);
    return result;
  } catch (error) {
    // Silently ignore if the user just closes the window
    if (error.code === 'auth/popup-closed-by-user' || error.code === 'auth/cancelled-popup-request') {
      console.log('Sign-in cancelled by user.');
      return null;
    }
    console.error('Authentication error:', error);
    throw error;
  }
}

export function signOut() {
  return firebaseSignOut(auth);
}